import styled from '@emotion/styled';
import React from 'react';
import { __ } from '../../helpers/TranslationService';
import useFlights from '../../hooks/useFlights';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import { AirplaneIcon } from '../Icons/AirplaneIcon';
import { RequestFormSelect } from '../RequestForm/RequestFormSelect';
import { SectionContainer, SectionHeader } from './CruiseInquiryForm.style';
import { IField } from './useInquiryFormValidation';
import { useActions } from '../../hooks/useActions';

const StyledRequestFormSelect = styled(RequestFormSelect)`
    select {
        text-align: left;
        text-align-last: left;
    }
`;

const StyledError = styled.p`
    color: ${(props) => props.theme.colors.watermelon['100']};
`;

export const CruiseInquiryFlightSelection = ({
    flightField,
    isAllInclusive,
}: {
    flightField: IField;
    isAllInclusive?: boolean;
}) => {
    const { pageData, requestForm, cruisePage } = useTypedSelector((state) => state);
    const { setAirportCode } = useActions();

    const handleSetAirportCode = (value: string) => {
        setAirportCode(value);
    };

    const airports = useFlights({
        includesFlight: cruisePage.includesFlight,
        cabins: cruisePage.cabins,
        selectedCabin: cruisePage.selectedCabin,
        rates: cruisePage.rates,
        currency: pageData.appConfig.defaultCurrency,
        cabinNid: requestForm.cabinNid,
        cruisePageAirports: cruisePage.airports,
        selectedSail: cruisePage.selectedSailIndex,
        sailNid: requestForm.sailNid,
        passengersNum: requestForm?.passengers?.length,
        isAllInclusive,
    });

    const airportOptions = airports.options;
    const isInvalidField = flightField.control.isDirty && !flightField.control.isValid;

    return (
        <SectionContainer>
            <SectionHeader>{__('cruiseData.flightMandatory', 'dreamlines')}</SectionHeader>
            <StyledRequestFormSelect
                key={requestForm.selectedAirportCode}
                id="reqform-v2-flight"
                defaultValue={requestForm.selectedAirportCode ?? ''}
                icon={<AirplaneIcon width={16} height={16} />}
                options={airportOptions}
                onChange={handleSetAirportCode}
                hasErrors={isInvalidField}
            />
            {isInvalidField && <StyledError> {flightField.control.errors} </StyledError>}
        </SectionContainer>
    );
};
